import { render } from "./InstallVideo.vue?vue&type=template&id=ffb81852"
import script from "./InstallVideo.vue?vue&type=script&lang=js"
export * from "./InstallVideo.vue?vue&type=script&lang=js"
script.render = render

export default script